import { useMemo } from 'react';

export const useUserPermissions = (currentUserAccess) => {
    const canConfigureFilePermissions = useMemo(() => {
        return (file) => {
            if (!currentUserAccess?.fileAccess) return false;
            const userAccess = currentUserAccess.fileAccess.find(access =>
                access.baseFileId === file.baseFileId
            );
            return userAccess?.canRead === true;
        };
    }, [currentUserAccess]);

    const getCurrentUserFileAccess = useMemo(() => {
        return (file) => {
            if (!currentUserAccess?.fileAccess) return null;
            return currentUserAccess.fileAccess.find(access =>
                access.baseFileId === file.baseFileId
            );
        };
    }, [currentUserAccess]);

    const getAccessibleFiles = useMemo(() => {
        return (allFiles) => {
            return allFiles.filter(file => canConfigureFilePermissions(file));
        };
    }, [canConfigureFilePermissions]);

    // Новая функция для проверки доступности файла
    const isFileAccessible = useMemo(() => {
        return (file) => {
            return canConfigureFilePermissions(file);
        };
    }, [canConfigureFilePermissions]);

    return {
        canConfigureFilePermissions,
        getCurrentUserFileAccess,
        getAccessibleFiles,
        isFileAccessible // Добавляем новую функцию
    };
};